import React from "react";
import BackArrow from "../../assets/backArrow.svg";
import { WEBSITE_DATA } from "../../constants/dashboard";
import { useNavigate, useLocation } from "react-router-dom";
import "./style.css";

const SAMobileView = () => {
  const navigate = useNavigate();
  const {
    state: { prototypeLink },
  } = useLocation();

  return (
    <>
      <div className="head">
        <img
          src={BackArrow}
          className="back"
          alt="back"
          onClick={() => navigate("/cp")}
        />
        <img id="img" src={WEBSITE_DATA?.logo} alt="title" />
      </div>
      <div className="mobileView">
        <iframe
          title="title"
          allowtransparency="true"
          className="iframe"
          src={prototypeLink}
          allowFullScreen
        ></iframe>
      </div>
    </>
  );
};

export default SAMobileView;
